import React from 'react';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import DatePicker from 'components/pure/utils/form/DatePicker';
import './DateRange.styl';

export default class DateRange extends React.PureComponent {
  render() {
    const {label, startDate, endDate = this.props.defaultEndDate.clone().endOf('day')} = this.props;
    return (
      <FieldContainer
        label={label || 'Date Range'}
        className="ev-date-range date-range"
        labelType="div">
        <DatePicker
          value={startDate}
          maxDate={
            endDate
              ? this.props.sameDateNotAllowed
                ? endDate.clone().subtract(1, 'day')
                : endDate
              : this.props.maxDate
          }
          hintText="Start Date"
          onChange={startDate => this.props.onUpdateRange({startDate, endDate})}
        />
        <div className="to">to</div>
        <DatePicker
          value={endDate}
          minDate={
            startDate
              ? this.props.sameDateNotAllowed
                ? startDate.clone().add(1, 'day')
                : startDate
              : startDate
          }
          maxDate={this.props.maxDate}
          hintText="End Date"
          onChange={endDate =>
            this.props.onUpdateRange({
              startDate: startDate ? startDate : endDate.clone().subtract(30, 'days'),
              endDate: endDate.clone().endOf('day'),
            })
          }
        />
      </FieldContainer>
    );
  }
}
